import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { STATUSES, STATUS_COLORS, TYPE_LABELS, TYPE_COLORS, fmtDate } from "./constants";

const typeFilters = [
  { key: "", label: "Tutte" },
  { key: "Utenze", label: "Utenze" },
  { key: "Credito", label: "Credito" },
  { key: "Controllo CRIF", label: "Controllo CRIF" },
  { key: "Controllo Banche Dati", label: "Banche Dati" },
  { key: "Assistenza Stradale", label: "Assistenza Stradale" },
  { key: "Assicurazioni", label: "Assicurazioni" },
];

export default function AdminRequests() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("");

  const load = useCallback(() => {
    const params = {};
    if (category) params.category = category;
    if (status) params.status = status;
    api.get("/admin/requests", { params }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [category, status]);

  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-requests-page" className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold text-[#0A192F]">Richieste</h1>
        <p className="mt-1 text-slate-600">Tutte le richieste dei clienti.</p>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <div className="flex flex-wrap gap-2">
          {typeFilters.map((f) => (
            <button key={f.key} data-testid={`admin-filter-type-${f.key ? f.key.toLowerCase().replace(/[^a-z]/g, "") : "all"}`} onClick={() => setCategory(f.key)}
              className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${category === f.key ? "bg-[#0A192F] text-white" : "bg-white text-slate-600 border border-slate-200 hover:border-[#0A192F]"}`}>
              {f.label}
            </button>
          ))}
        </div>
        <select data-testid="admin-filter-status" value={status} onChange={(e) => setStatus(e.target.value)}
          className="ml-auto rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 outline-none focus:ring-2 focus:ring-[#10B981]">
          <option value="">Tutti gli stati</option>
          {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      {items === null ? (
        <div className="py-20 text-center text-slate-400">Caricamento...</div>
      ) : items.length === 0 ? (
        <div data-testid="admin-requests-empty" className="rounded-2xl border border-dashed border-slate-300 bg-white py-16 text-center text-slate-500">
          Nessuna richiesta trovata con questi filtri.
        </div>
      ) : (
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="border-b border-slate-200 bg-[#F8FAFC] text-xs uppercase tracking-wide text-slate-500">
                <tr>
                  <th className="px-5 py-3 font-semibold">Data</th>
                  <th className="px-5 py-3 font-semibold">Cliente</th>
                  <th className="px-5 py-3 font-semibold">Categoria</th>
                  <th className="px-5 py-3 font-semibold">Tipo richiesta</th>
                  <th className="px-5 py-3 font-semibold">Stato</th>
                  <th className="px-5 py-3 font-semibold">Assegnato a</th>
                  <th className="px-5 py-3 font-semibold">Aggiornato</th>
                </tr>
              </thead>
              <tbody>
                {items.map((r) => (
                  <tr key={r.id} data-testid={`admin-request-row-${r.id}`} onClick={() => navigate(`/admin/richieste/${r.id}`)}
                    className="cursor-pointer border-b border-slate-100 transition-colors last:border-0 hover:bg-[#F8FAFC]">
                    <td className="px-5 py-4 text-slate-500">{fmtDate(r.created_at)}</td>
                    <td className="px-5 py-4">
                      <p className="font-semibold text-[#0A192F]">{r.client_name || "—"}</p>
                      <p className="text-xs text-slate-400">{r.client_email}</p>
                    </td>
                    <td className="px-5 py-4">
                      <span className="rounded-full px-2.5 py-1 text-xs font-bold text-white" style={{ backgroundColor: TYPE_COLORS[r.type] || "#0A192F" }}>
                        {r.category || TYPE_LABELS[r.type] || r.type}
                      </span>
                    </td>
                    <td className="px-5 py-4 text-slate-700">{r.subcategory}</td>
                    <td className="px-5 py-4">
                      <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS_COLORS[r.status] || "bg-slate-100 text-slate-600"}`}>{r.status}</span>
                    </td>
                    <td className="px-5 py-4 text-slate-600">{r.assigned_to || <span className="text-slate-300">Non assegnato</span>}</td>
                    <td className="px-5 py-4 text-slate-500">{fmtDate(r.updated_at || r.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
